import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10.363 20.405l-8.106 -13.534a1.914 1.914 0 0 1 1.636 -2.871h16.214a1.914 1.914 0 0 1 1.636 2.871l-8.106 13.534a1.914 1.914 0 0 1 -3.274 0","key":"svg-0"}]]

const IconTriangleInverted = createReactComponent('outline', 'triangle-inverted', 'TriangleInverted', __iconNode);

export default IconTriangleInverted;